import styled, { css } from 'styled-components';

import { colors } from '../../utils/variables.styles';

const Content = styled.div`
  display: flex;
  align-items: center;
  min-height: 45px;
  width: calc(100% - 65px);
`;

const StyledTitle = styled.div`
  margin-right: 5px;
  max-width: 190px;
  width: 100%;
font-size: 15px;
`;

const SelectedWrapper = styled.div`
  width: 100%;
  font-weight: 700;
  font-family: "Lato", sans-serif;
`;

const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'nested'
})`
  padding: 0 24px;
  background: ${colors.white};

  ${(props) => props.nested && css`
    background: ${colors.whiteer || colors.white};
  `}
`;

export {
  Content,
  StyledTitle,
  SelectedWrapper,
  Container
};
